<dx-accordion [dataSource]="[0]" [collapsible]="true" [multiple]="false" [animationDuration]="1000"
              (onSelectionChanged)="collapsibleChange($event)"
              height="fit-content">
  <div *dxTemplate="let t of 'title'">
    <h3>{{title}}</h3>
  </div>
  <div class="padding-block" *dxTemplate="let c of 'item'">
    <form [formGroup]="form" (ngSubmit)="search()">
      <div fxLayout="row" fxLayoutAlign="space-between stretch">
        <div fxLayout="column" [ngStyle.xs]="{width: '100%'}" [ngStyle.sm]="{width: '60%'}">
          <app-from-to-date-range-selector
            [startGroupControl]="convertToFormControl(form?.get('start'))"
            [endGroupControl]="convertToFormControl(form?.get('end'))">
          </app-from-to-date-range-selector>
        </div>
        <app-client-selector fxShow fxHide.lt-md [ngStyle.md]="{width: '50%', 'padding-left': '20px' }"
                             [clearBtn]="false" id="clientSelector"
                             [selection]="'multiple'"
                             [resultEntry]="true"
                             [control]="form?.get('clients')"></app-client-selector>
        <div app-order-status-selector [control]="form?.get('statuses')"></div>
        <div app-order-priority-selector [control]="form?.get('priorities')"></div>
      </div>
      <div fxLayout="row" fxLayoutAlign="end end" style="padding-left: 30px; padding-bottom: 5px; margin-top: 8px">
        <app-search-btn style="margin-right: 4px" [disabled]="!form?.valid" (click)="search()"></app-search-btn>
        <app-clear-all-btn (click)="clear()"></app-clear-all-btn>
      </div>
    </form>
  </div>
</dx-accordion>
